@if(isLoading()){
  <div class="h-[50px] p-3 flex items-center">
    <app-pan-spinner></app-pan-spinner>
  </div>
}

@else if(photoLink()) {
  <app-pan-image-preview-button data-testid="image-preview-button" [src]="photoLink()" [modalTopLevel]="true" />
}